import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./EditReferralCodeForm";
import {cancelCreateReferralCode} from "../../actions/SalesApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence,} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "code");
  errors = validatePresence(errors, values, "description");
  return errors.toJS();
}

function coerceBoolean(val) {
  if (val === "true") return true;
  if (val === true) return true;
  return false;
}

class CreateReferralCodeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("active", coerceBoolean(values.get("active")));
    return this.props.createReferralCode(updatedValues.toJS())
      .then((response) => {
        if (response.data.createReferralCode.errors.length <= 0) {
          this.props.cancelCreateReferralCode();
        } else {
          let errors = createValidationErrors(response.data.createReferralCode.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCreateReferralCode();
  }

  render() {
    let initialValues = fromJS({
      code: "",
      description: "",
      active: true
    })
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CREATE_REFERRAL_CODE = gql`
  mutation createReferralCode($data: ReferralCodeInput!) {
    createReferralCode(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(CREATE_REFERRAL_CODE, {
    props: ({mutate}) => ({
      createReferralCode: (data) => mutate({
        variables: {data: data}
      })
    })
  })
)

export default connect(null, {cancelCreateReferralCode})(withQueries(CreateReferralCodeFormContainer));